import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ApiConnectorService } from '../__api/api-connector.service';
import { FunctionsService } from '../__common/functions.service';
import { ResolverService } from '../__common/resolver.service';
import { GuiFlowService } from '../__gui/gui-flow.service';

@Injectable({
  providedIn: 'root'
})
export class LoginManagerService {

  loading = false;
  error = false;
  voyjaleasSessionToken;
  voyjaleasSessionUsername;
  
  private sessionData;

  constructor(private router: Router,private apiConnector:ApiConnectorService,private resolver: ResolverService,private _snackBar: MatSnackBar) { }


  closeSession(){
    let log = { username: this.sessionData.id,operation: 'logout'};
    /* this.apiConnector.postUserSessionLog('post','sessionLog',log).subscribe(res => this.savedLog(res)); */
  }

  savedLog(res){
    console.log('Saved user session log');
  }

  areThereAnyCookies(){
    this.voyjaleasSessionToken = this.getCookie('voyjaleasSessionToken');
    this.voyjaleasSessionUsername = this.getCookie('voyjaleasSessionUsername');
  }

  delete_cookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  saveCookie(cname, cvalue, exdays){
    const d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      let expires = "expires="+ d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  validateCookies(loginObj,tokenCookie,usernameCookie){
    debugger
    //this.apiConnector.login('cookiesDashLogin',usernameCookie,tokenCookie).subscribe(res => this.processValidationToken(res,loginObj));
  }

  processValidationToken(response,loginObj){
    this.loading = false;
    if(response){
      if(response.OK){
        this.saveConfigCookiesData(response,loginObj);
        this.reroute(loginObj,response);
      }else
      if(response.KO){
        this.openSimpleSnackBar('Los datos son incorrectos.','Ok');
      }else{
        this.openSimpleSnackBar('Contacte a su administrador','Ok');
      }
    }else{
      this.openSimpleSnackBar('Error en el servidor','Ok');
    }
  }


  reroute(loginObj,response){
    
    /* response && response.id? this.resolver.setSelectedClientId(response.id) : null; */    
    this.resolver.getDashboardData(true);
    this.goToPage('/client-board');


    /* switch(loginObj.path){
      case 'login':
        if(response.role=='user' || response.role=='admin' || response.role=='employee'){
          
        }else{
          this.openSimpleSnackBar('Rol sin permisos','Ok');
        }
        break;
      default:
        console.log('Error on reroute after successfull login');
        break;
    } */
  }

  saveConfigCookiesData(res,obj){
    // User Session Data
    this.sessionData = {
      driveUrl: res.driveUrl,
      email: res.email,
      id: res.id,
      lastname: res.lastname,
      logged: res.logged,
      name: res.name,
      role:res.role,
      goal: res.goal,
      token: obj.token? obj.token : null,
      username: obj.username? obj.username : null
    };
/*     this.apiConnector.saveSessionData(this.sessionData);
    this.resolver.saveUserSessionData(this.sessionData); */
    let log = { username: obj.username,operation: 'login'};
    /* this.apiLogin.postUserSessionLog('post','sessionLog',log).subscribe(res => this.savedLog(res)); */
    this.saveCookie('voyjaleasSessionToken',obj.token,1);
    this.saveCookie('voyjaleasSessionUsername',obj.username,1);
  }

  saveConfigData(res,obj){
    // User Session Data
    this.sessionData = {
      driveUrl: res.driveUrl,
      email: res.email,
      id: res.id,
      lastname: res.lastname,
      logged: res.logged,
      name: res.name,
      role:res.role,
      goal: res.goal,
      username: obj.username? obj.username : null
    };
    
    /* this.apiConnector.saveSessionData(this.sessionData); */
    /* this.resolver.saveUserSessionData(this.sessionData); */

    let log = { username: obj.username,operation: 'login'};
    /* this.apiLogin.postUserSessionLog('post','sessionLog',log).subscribe(res => this.savedLog(res)); */
    let historic = {
      operation: 'login to dashboard',
      previousObj: JSON.stringify({}),
      newObj: JSON.stringify(this.sessionData),
      FK_ID_clientDetails: this.sessionData.id
    };
    //debugger
    this.apiConnector.createHistoric(historic,'loginpost');
    this.saveCookie('voyjaleasSessionToken',res.token,1);
    this.saveCookie('voyjaleasSessionUsername',obj.username,1);
  }
  
  initApp(res,obj){
    this.saveConfigData(res,obj);
    this.resolver.resolveDependenciesToStart();
    this.reroute(obj,res);
  }

  processIsUserLoggedIn(res,obj){
    debugger
    this.loading = false;
    if(res){
      if(res.success){
        this.initApp(res,obj);
        this.saveConfigData(res,obj);
        this.reroute(obj,res);
      }else
      if(res.KO){
        this.openSimpleSnackBar('Los datos son incorrectos.','Ok');
      }else{
        this.openSimpleSnackBar('Error en el servidor','Ok');
      }
    }else{
      this.openSimpleSnackBar('Los datos son incorrectos.','Ok');
    }
  }

  getLoading(){
    return this.loading;
  }

  goToPage(page: string) {
    this.router.navigateByUrl(page);
  }

  getSessionData(){
    return this.sessionData;
  }

  openSimpleSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }

  checkForCookies(route){
    switch(route){
      case 'dashboard':
        if(this.getCookie('voyjaleasSessionToken') && this.getCookie('voyjaleasSessionUsername')){
          return true;
        }else{
          return false;
        }
      case 'login':
        if(this.getCookie('voyjaleasSessionToken') && this.getCookie('voyjaleasSessionUsername')){
         return true;
        }else{
          return false;
        }
      default:
        break;
      }
  }

  isLoading(){
    return this.loading;
  }
}
